<div class="appContentsContainer">
  <form
    [formGroup]="mastertable"
    (ngSubmit)="onSave()"
    *ngIf="formLoaded"
    class="formGroup container halfForm"
  >
    <div
      class="pageTitle collapsibleTitle"
      *ngIf="type == 'D' && operation === 'creacion'"
    >
      {{ "mastertablesD.titleCreateRegistry" | translate }}
      {{ mastertableId }}
    </div>
    <div
      class="pageTitle collapsibleTitle"
      *ngIf="type == 'D' && operation === 'edicion'"
    >
      {{ "mastertablesD.titleEditRegistry" | translate }} {{ mastertableId }}
    </div>
    <div
      class="pageTitle collapsibleTitle"
      *ngIf="type == 'S' && operation === 'creacion'"
    >
      {{ "mastertablesS.titleCreateRegistry" | translate }}
      {{ mastertableId }}
    </div>
    <div
      class="pageTitle collapsibleTitle"
      *ngIf="type == 'S' && operation === 'edicion'"
    >
      {{ "mastertablesS.titleEditRegistry" | translate }} {{ mastertableId }}
    </div>
    <div class="lineGradient"></div>

    <div class="row shortRow" *ngFor="let field of fields">
      <div
        class="itemContainer col"
        *ngIf="field.tipo == types.text && hideFields(field.nombre)"
      >
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="{{ field.nombre }}" for="{{ field.nombre }}"
              >{{ getLabelName(field.nombre) }}
            </label>
          </div>
        </div>
        <div class="inputContainer">
          <input type="text" formControlName="{{ field.nombre }}" />
          <div *ngIf="field.nullable == 0" class="supIndexRequest">*</div>
        </div>
      </div>
      <div
        class="itemContainer col"
        style="min-height: 200px"
        *ngIf="field.tipo == types.textArea && hideFields(field.nombre)"
      >
        <div class="seachLabel inputLabelContainer" style="min-height: 200px">
          <div class="inputLabel">
            <label id="{{ field.nombre }}" for="{{ field.nombre }}"
              >{{ getLabelName(field.nombre) }}
            </label>
          </div>
        </div>
        <div class="inputContainer" style="min-height: 200px">
          <textarea
            type="text"
            style="resize: none"
            formControlName="{{ field.nombre }}"
          ></textarea>
          <div *ngIf="field.nullable == 0" class="supIndexRequest">*</div>
        </div>
      </div>
      <div class="itemContainer col" *ngIf="field.tipo == types.number">
        <div
          class="seachLabel inputLabelContainer"
          *ngIf="field.nombre != 'ID'"
        >
          <div class="inputLabel">
            <label id="{{ field.nombre }}" for="{{ field.nombre }}"
              >{{ getLabelName(field.nombre) }}
            </label>
          </div>
        </div>

        <div
          class="inputContainer"
          *ngIf="
            field.nombre == 'PR_PRECIO' || field.nombre == 'PR_NUEVO_PRECIO';
            else numberBlock
          "
        >
          <input
            type="text"
            formControlName="{{ field.nombre }}"
            appPriceFormat
          />
          <div *ngIf="field.nullable == 0" class="supIndexRequest">*</div>
        </div>
        <ng-template #numberBlock>
          <div class="inputContainer" *ngIf="field.nombre != 'ID'">
            <input type="number" formControlName="{{ field.nombre }}" />
            <div *ngIf="field.nullable == 0" class="supIndexRequest">*</div>
          </div>
        </ng-template>
      </div>
      <div
        class="itemContainer col"
        *ngIf="field.tipo == types.date || field.tipo == types.dateAux"
      >
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label id="{{ field.nombre }}" for="{{ field.nombre }}"
              >{{ getLabelName(field.nombre) }}
            </label>
          </div>
        </div>
        <div class="inputContainer">
          <input type="date" formControlName="{{ field.nombre }}" />
          <div *ngIf="field.nullable == 0" class="supIndexRequest">*</div>
        </div>
      </div>
      <div class="itemContainer col" *ngIf="field.tipo == types.blob">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel" for="otroDocumentoAdjuntar">
            <label id="{{ field.nombre }}" for="{{ field.nombre }}"
              >{{ getLabelName(field.nombre) }}
            </label>
          </div>
        </div>
        <div class="inputContainer">
          <div class="dummyButtonContainer">
            <div class="dummyButton">
              <em class="fas fa-file-upload"></em>
            </div>
            <div class="dummyFileInput" style="min-height: 20px !important">
              <div
                class="dummyFileName adjustText"
                style="max-height: 20px !important"
              >
                {{ construyeNombreDeFicheroParaDescargar(field) }}
              </div>
            </div>
          </div>
          <input
            formControlName="{{ field.nombre }}"
            class="inputFile detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
            type="file"
            id="documentacion"
            (change)="handleFileInput($event, field.nombre)"
          />
          <div *ngIf="field.nullable == 0" class="supIndexRequest">*</div>
          <div
            *ngIf="getBinario(field.nombre) != null"
            class="dummyButtonContainer"
            style="
              margin-left: 5px;
              position: relative;
              cursor: pointer;
              z-index: 1;
            "
            title="Haz clic aquí para descargar el fichero {{
              construyeNombreDeFicheroParaDescargar(field)
            }}"
            (click)="downloadFile(field)"
          >
            <div class="dummyButton">
              <em class="fas fa-file-download"></em>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          *ngIf="mastertable.pristine"
          type="button"
          (click)="goList()"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
        <button
          class="formButtonBack"
          *ngIf="!mastertable.pristine"
          [swal]="confirmSwal"
          type="button"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goList()"
    >
    </swal>
  </form>
</div>
